export const COLUMN_ACTION_GROUP = 'Column';
